import { cn } from '@shared/lib';

interface UserAvatarProps {
  initials: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-12 w-12 text-lg',
};

export function UserAvatar({ initials, size = 'md', className }: UserAvatarProps) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-[10px] bg-accent text-fg-inv font-serif font-semibold',
        sizes[size],
        className,
      )}
    >
      {initials}
    </div>
  );
}
